import { FLAGR_ENTITY_ID_KEY } from '../constants';

let inMemoryFlagrEntityId: string | null = null;

export const generateUUID = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getOrCreateFlagrEntityId = () => {
  if (inMemoryFlagrEntityId) {
    return inMemoryFlagrEntityId;
  }

  try {
    let id = window.localStorage.getItem(FLAGR_ENTITY_ID_KEY);
    if (!id) {
      id = generateUUID();
      window.localStorage.setItem(FLAGR_ENTITY_ID_KEY, id);
    }
    inMemoryFlagrEntityId = id;
    return id;
  } catch {
    inMemoryFlagrEntityId = generateUUID();
    return inMemoryFlagrEntityId;
  }
};
